module.exports = __webpack_public_path__ + "static/img/ad3.02d5c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ad3.png
// module id = iF42
// module chunks = 30